var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBigPlusPlanIcon = function SvgBigPlusPlanIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6776 10.9335L20.0014 20.0002L4.3252 10.9335C4.64706 10.3764 5.10605 9.91089 5.65853 9.58116L18.0966 2.4002C19.2789 1.73346 20.7238 1.73346 21.9061 2.4002L34.3442 9.58116C34.8967 9.91089 35.3557 10.3764 35.6776 10.9335Z",
    fill: "#E9FFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 20V38.0953C19.3985 38.0944 18.8059 37.9577 18.2657 37.6953L5.71336 30.4381C4.53675 29.7574 3.81117 28.5022 3.80859 27.1429V12.8572C3.81176 12.1823 3.9889 11.5197 4.32288 10.9333L19.9991 20Z",
    fill: "#5CD6AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1905 12.8572V27.1429C36.1879 28.5022 35.4623 29.7574 34.2857 30.4381L21.6762 37.7143C21.1518 37.9616 20.5798 38.0916 20 38.0953V20L35.6762 10.9333C36.0102 11.5197 36.1873 12.1823 36.1905 12.8572Z",
    fill: "#ADEBD6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigPlusPlanIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bigPlusPlanIcon.1a595fca.svg";
export { ForwardRef as ReactComponent };